/* Rozana Bazaar — theme.js */
window.RB = (function () {
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function moneyFormat(cents) {
    return 'Rs ' + (cents / 100).toLocaleString('en-PK', { maximumFractionDigits: 0 });
  }

  function openDrawer() {
    var d = qs('#rb-drawer'), o = qs('#rb-overlay');
    if (d) d.classList.add('open');
    if (o) o.classList.add('open');
  }
  function closeDrawer() {
    var d = qs('#rb-drawer'), o = qs('#rb-overlay');
    if (d) d.classList.remove('open');
    if (o) o.classList.remove('open');
  }
  function closeMobileNav() {
    var nav = qs('.main-nav');
    if (nav) nav.classList.remove('open');
  }

  /* ===== Fly-to-cart animation (laptop / desktop / mobile) ===== */
  (function injectFlyStyles() {
    var s = document.createElement('style');
    s.textContent =
      '.rb-fly{position:fixed;left:0;top:0;z-index:100000;border-radius:50%;pointer-events:none;' +
      'background-color:#fff;background-size:cover;background-position:center;' +
      'border:2px solid #C9A227;box-shadow:0 8px 22px rgba(0,0,0,.28);will-change:transform,opacity;}' +
      '@keyframes rb-bump{0%{transform:scale(1)}35%{transform:scale(1.18)}65%{transform:scale(.94)}100%{transform:scale(1)}}' +
      '@keyframes rb-pop{0%{transform:scale(1)}40%{transform:scale(1.5)}100%{transform:scale(1)}}' +
      '.cart-btn.rb-bump{animation:rb-bump .5s ease}' +
      '.cart-btn.rb-bump .cart-count{display:inline-block;animation:rb-pop .5s ease}' +
      '@media (prefers-reduced-motion:reduce){.cart-btn.rb-bump,.cart-btn.rb-bump .cart-count{animation:none}}';
    (document.head || document.documentElement).appendChild(s);
  })();

  function visibleCartBtn() {
    var list = document.querySelectorAll('.cart-btn');
    for (var i = 0; i < list.length; i++) {
      var r = list[i].getBoundingClientRect();
      if (r.width > 0 && r.height > 0) return list[i];
    }
    return null;
  }

  function findSourceImg(el) {
    var scope = el && el.closest ? el : null;
    var card = scope && scope.closest('.card');
    if (card) { var a = qs('.thumb img', card); if (a) return a; }
    var rec = scope && scope.closest('.drawer-rec-card');
    if (rec) { var b = qs('.drc-thumb img', rec); if (b) return b; }
    return qs('#pg-main-img');
  }

  function bumpCart(target) {
    if (!target) return;
    target.classList.remove('rb-bump');
    void target.offsetWidth;
    target.classList.add('rb-bump');
    setTimeout(function () { target.classList.remove('rb-bump'); }, 600);
  }

  /* Returns a Promise that resolves when the animation has finished. */
  function flyToCart(srcEl) {
    return new Promise(function (resolve) {
      try {
        var target = visibleCartBtn();
        var img = findSourceImg(srcEl);
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!target || !img || !img.getBoundingClientRect || !document.body.animate || reduce) {
          bumpCart(target);
          return resolve();
        }
        var ir = img.getBoundingClientRect();
        var tr = target.getBoundingClientRect();
        var vw = window.innerWidth, vh = window.innerHeight;
        /* start point: centre of the visible part of the image */
        var sx = Math.min(Math.max(ir.left + ir.width / 2, 20), vw - 20);
        var sy = Math.min(Math.max(ir.top + ir.height / 2, 20), vh - 20);
        /* end point: cart button (clamped to the viewport if header is scrolled away) */
        var tx = Math.min(Math.max(tr.left + tr.width / 2, 20), vw - 20);
        var ty = Math.min(Math.max(tr.top + tr.height / 2, 20), vh - 20);
        var size = vw < 600 ? 64 : 84;
        var dot = document.createElement('div');
        dot.className = 'rb-fly';
        dot.style.width = size + 'px';
        dot.style.height = size + 'px';
        if (img.currentSrc || img.src) dot.style.backgroundImage = 'url("' + (img.currentSrc || img.src) + '")';
        document.body.appendChild(dot);
        var h = size / 2;
        var mx = (sx + tx) / 2;
        var my = Math.min(sy, ty) - Math.min(120, vh * 0.18);
        if (my < 10) my = 10;
        var anim = dot.animate([
          { transform: 'translate(' + (sx - h) + 'px,' + (sy - h) + 'px) scale(1)', opacity: 1, offset: 0 },
          { transform: 'translate(' + (mx - h) + 'px,' + (my - h) + 'px) scale(.6)', opacity: 1, offset: 0.5 },
          { transform: 'translate(' + (tx - h) + 'px,' + (ty - h) + 'px) scale(.12)', opacity: 0.5, offset: 1 }
        ], { duration: 800, easing: 'cubic-bezier(.45,.05,.55,.95)', fill: 'forwards' });
        var done = false;
        function finish() {
          if (done) return;
          done = true;
          if (dot.parentNode) dot.parentNode.removeChild(dot);
          bumpCart(target);
          resolve();
        }
        anim.onfinish = finish;
        setTimeout(finish, 1100);
      } catch (err) {
        resolve();
      }
    });
  }

  function renderDrawer(cart) {
    var itemsEl = qs('#rb-drawer-items');
    var totalEl = qs('#rb-drawer-total');
    var countEls = document.querySelectorAll('.cart-count');
    var drawerCountEl = qs('#rb-drawer-count');
    var savingsEl = qs('#rb-drawer-savings');
    if (!itemsEl) return;

    if (!cart.items || cart.items.length === 0) {
      itemsEl.innerHTML = '<div class="drawer-empty">Your cart is empty.</div>';
    } else {
      itemsEl.innerHTML = cart.items.map(function (item) {
        var img = item.image ? item.image : '';
        var variantLine = (item.variant_title && item.variant_title !== 'Default Title')
          ? '<span class="drawer-item-variant">' + item.variant_title + '</span>' : '';
        var oldPrice = (item.original_line_price > item.final_line_price)
          ? '<span class="dip-old">' + moneyFormat(item.original_line_price) + '</span>' : '';
        return (
          '<div class="drawer-item">' +
            '<div class="drawer-thumb">' + (img ? '<img src="' + img + '" alt="' + item.product_title + '">' : '') + '</div>' +
            '<div class="drawer-item-info">' +
              '<h5>' + item.product_title + '</h5>' +
              variantLine +
              '<div class="drawer-item-bottom">' +
                '<div class="drawer-qty-stepper">' +
                  '<button type="button" class="dq-btn" data-qty-decrease data-key="' + item.key + '">–</button>' +
                  '<span class="dq-val">' + item.quantity + '</span>' +
                  '<button type="button" class="dq-btn" data-qty-increase data-key="' + item.key + '">+</button>' +
                '</div>' +
                '<button type="button" class="drawer-remove" data-key="' + item.key + '">Remove</button>' +
              '</div>' +
            '</div>' +
            '<div class="drawer-item-price">' +
              '<span class="dip-price">' + moneyFormat(item.final_line_price) + '</span>' +
              oldPrice +
            '</div>' +
          '</div>'
        );
      }).join('');
    }
    if (totalEl) totalEl.textContent = moneyFormat(cart.total_price);
    countEls.forEach(function (el) { el.textContent = cart.item_count; });
    if (drawerCountEl) drawerCountEl.textContent = cart.item_count;
    if (savingsEl) {
      if (cart.total_discount && cart.total_discount > 0) {
        savingsEl.style.display = '';
        savingsEl.textContent = "You're saving " + moneyFormat(cart.total_discount);
      } else {
        savingsEl.style.display = 'none';
      }
    }

    itemsEl.querySelectorAll('.drawer-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        updateItem(btn.getAttribute('data-key'), 0);
      });
    });
    itemsEl.querySelectorAll('[data-qty-increase]').forEach(function (btn) {
      btn.addEventListener('click', function () { stepQty(btn.getAttribute('data-key'), 1, cart); });
    });
    itemsEl.querySelectorAll('[data-qty-decrease]').forEach(function (btn) {
      btn.addEventListener('click', function () { stepQty(btn.getAttribute('data-key'), -1, cart); });
    });
  }

  function stepQty(key, delta, cart) {
    var current = 1;
    if (cart && cart.items) {
      var found = cart.items.find(function (i) { return i.key === key; });
      if (found) current = found.quantity;
    }
    var next = current + delta;
    if (next < 1) next = 0;
    updateItem(key, next);
  }

  function refreshCart() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(renderDrawer);
  }

  /* srcEl (optional): the button that was clicked, used to pick the image that flies. */
  function addToCart(variantId, qty, openAfter, srcEl) {
    var flyDone = flyToCart(srcEl);
    var request = fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return fetch('/cart.js'); })
      .then(function (r) { return r.json(); });
    Promise.all([request, flyDone])
      .then(function (res) {
        var cart = res[0];
        renderDrawer(cart);
        if (openAfter) setTimeout(openDrawer, 250);
      })
      .catch(function (err) { console.error('Add to cart failed', err); });
  }

  function updateItem(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(renderDrawer);
  }

  function buyNow(variantId, qty) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] })
    })
      .then(function () { window.location.href = '/checkout'; })
      .catch(function (err) { console.error('Buy now failed', err); });
  }

  function goToCheckout() {
    window.location.href = '/checkout';
  }

  function switchThumb(btn) {
    var full = btn.getAttribute('data-full');
    var mainImg = qs('#pg-main-img');
    if (mainImg && full) mainImg.src = full;
    document.querySelectorAll('.pg-thumb-btn').forEach(function (b) { b.classList.remove('active'); });
    btn.classList.add('active');
  }

  function switchTab(btn) {
    var tab = btn.getAttribute('data-tab');
    document.querySelectorAll('.pg-tab-btn').forEach(function (b) { b.classList.remove('active'); });
    document.querySelectorAll('.pg-tab-panel').forEach(function (p) { p.classList.remove('active'); });
    btn.classList.add('active');
    var panel = document.querySelector('.pg-tab-panel[data-panel="' + tab + '"]');
    if (panel) panel.classList.add('active');
  }

  function init() {
    document.addEventListener('click', function (e) {
      var buyBtn = e.target.closest('[data-buy-now]');
      var cartBtn = e.target.closest('[data-add-to-cart]');
      var openBtn = e.target.closest('[data-open-cart]');
      var closeBtn = e.target.closest('[data-close-cart]');
      var navToggle = e.target.closest('[data-nav-toggle]');
      var navLink = e.target.closest('.main-nav a');
      var thumbBtn = e.target.closest('.pg-thumb-btn');
      var tabBtn = e.target.closest('.pg-tab-btn');

      if (buyBtn) {
        e.preventDefault();
        buyNow(buyBtn.getAttribute('data-variant-id'), 1);
      }
      if (cartBtn) {
        e.preventDefault();
        addToCart(cartBtn.getAttribute('data-variant-id'), 1, true, cartBtn);
      }
      if (openBtn) { e.preventDefault(); openDrawer(); }
      if (closeBtn || e.target.id === 'rb-overlay') { closeDrawer(); }
      if (navToggle) {
        var nav = qs('.main-nav');
        if (nav) nav.classList.toggle('open');
      }
      if (navLink) { closeMobileNav(); }
      if (thumbBtn) { e.preventDefault(); switchThumb(thumbBtn); }
      if (tabBtn) { e.preventDefault(); switchTab(tabBtn); }
    });

    // Native product-page add-to-cart form (progressive enhancement)
    var pdpForm = qs('#rb-product-form');
    if (pdpForm) {
      pdpForm.addEventListener('submit', function (e) {
        var action = e.submitter && e.submitter.getAttribute('data-action');
        var variantId = qs('[name="id"]', pdpForm).value;
        var qty = parseInt(qs('[name="quantity"]', pdpForm).value || '1', 10);
        e.preventDefault();
        if (action === 'buy-now') {
          buyNow(variantId, qty);
        } else {
          addToCart(variantId, qty, true, e.submitter);
        }
      });
    }

    refreshCart();
  }

  document.addEventListener('DOMContentLoaded', init);

  return { openDrawer: openDrawer, closeDrawer: closeDrawer, addToCart: addToCart, buyNow: buyNow, goToCheckout: goToCheckout, flyToCart: flyToCart };
})();
